@if (type()) {
  @switch (type()) {
    @case (stockTypes.COMING_SOON) {
      <mat-icon
        class="status-icon" [class]="styleClass()" svgIcon="time"
        aria-label="Icon that displays a tooltip when hovered over"
      />
      <span class="status-label h-50" [dpTooltip]="'dpProductCommon.stock.comingSoon' | cxTranslate">Coming soon</span>
    }
    @case (stockTypes.IN_STOCK) {
      @if (lifecycleStatus() === 'LCS40') {
        <mat-icon
          class="status-icon" [class.last-pieces]="lifecycleStatus() === 'LCS40'" svgIcon="in-stock"
          aria-label="Icon that displays a tooltip when hovered over"
        ></mat-icon>
        <span class="status-label h-50" dpTooltip [contentTemplate]="tooltipContentRef"
              (mouseenter)="fetchStockDataIfNeeded()">Last pieces</span>
        <ng-template #tooltipContentRef>
          <div class="tooltip-content__header">
            {{ 'dpProductCommon.stock.inStockLCS40' | cxTranslate }}
            <span>
            {{ 'dpProductCommon.stock.noReplenishment' | cxTranslate }}
          </span>
          </div>
          <ng-container *ngTemplateOutlet="tooltipStockInfo"></ng-container>
        </ng-template>
      } @else {
        <mat-icon
          class="status-icon"
          [class.instock-not-default]="!isDefaultDC()"
          [class]="styleClass()" svgIcon="in-stock"
          aria-label="Icon that displays a tooltip when hovered over"
        ></mat-icon>
        <span class="status-label h-50" dpTooltip
              [contentTemplate]="tooltipStockTemplate"
              (mouseenter)="fetchStockDataIfNeeded()">In stock
        </span>
        <ng-template #tooltipStockTemplate>
          @if (stockData()) {
            <div class="tooltip-content">
            <div class="tooltip-content__header">
              @if (hasStockInDefaultDC()) {
                <p class="mb-0">{{ 'dpProductCommon.stock.inStockDefaultDC' | cxTranslate }}</p>
              } @else {
                <p class="mb-0">{{ 'dpProductCommon.stock.inStockForeignDC' | cxTranslate }}</p>
                <p class="mb-0">{{ 'dpProductCommon.stock.deliveryTime' | cxTranslate }}</p>
              }
            </div><ng-container *ngTemplateOutlet="tooltipStockInfo"></ng-container>
          </div>
          }
      </ng-template>
      }
    }
    @case (stockTypes.DATE_CONFIRMATION) {
      <ng-container *ngTemplateOutlet="dateConfirmationTemplate; context: { $implicit: styleClass() }"></ng-container>
    }
    @case (stockTypes.OBSOLETE) {
      <mat-icon
        class="status-icon" [class]="styleClass()" svgIcon="obsolete"
        aria-label="Icon that displays a tooltip when hovered over"
      ></mat-icon>
      <span class="status-label h-50" dpTooltip [contentTemplate]="tooltipContentRef">Obsolete</span>
      <ng-template #tooltipContentRef>
        @if (replacementProductCode()) {
          {{ 'dpProductCommon.stock.obsoletePrefix' | cxTranslate }}
          <cx-generic-link [url]="{ code: replacementProductCode() } | cxProductUrl" [target]="'_blank'">
            {{ 'dpProductCommon.stock.obsoleteLinkLabelLink' | cxTranslate }}
          </cx-generic-link>
          {{ 'dpProductCommon.stock.obsoleteSuffix' | cxTranslate }}
        } @else {
          {{ 'dpProductCommon.stock.obsolete' | cxTranslate }}
        }
      </ng-template>
    }
    @case (stockTypes.REPLENISHMENT_DATE) {
      @if (replenishmentDate()) {
        <mat-icon
          class="status-icon" [class]="styleClass()" svgIcon="replenishment"
          aria-label="Icon that displays a tooltip when hovered over"
        ></mat-icon>
        <span class="status-label h-50" [class]="styleClass()" dpTooltip
              [contentTemplate]="tooltipContentRef">Replenish-ment</span>
        <ng-template #tooltipContentRef>
          <span class="body-medium h-200">{{ 'dpProductCommon.stock.replenishmentDate' | cxTranslate }}: </span>
          <span class="h-200">{{ 'dpProductInfo.details.week.title' | cxTranslate }} {{ replenishmentDate() }}</span>
        </ng-template>
      } @else {
        <ng-container *ngTemplateOutlet="dateConfirmationTemplate;
          context: { $implicit: stockTypes.DATE_CONFIRMATION.toLowerCase() }"></ng-container>
      }
    }
  }
  <ng-template #tooltipStockInfo>
    <ul class="tooltip-content__description m-0 p-0">
      @for (dc of stockInfo(); track dc.warehouse) {
        <li>
          <p class="mb-0">
            {{ dc.warehouse }}
            @if (dc.isDefault) {
              ({{ 'dpProductCommon.stock.default' | cxTranslate }})
            }
          </p>
          <span class="h-200">
          {{ dc.stockLevel }} {{ 'dpProductInfo.details.pcs.title' | cxTranslate }}
        </span>
        </li>
      }
    </ul>
  </ng-template>

  <ng-template #dateConfirmationTemplate let-styleClass>
    <mat-icon
      class="status-icon" [class]="styleClass" svgIcon="info"
      aria-label="Icon that displays a tooltip when hovered over"
    ></mat-icon>
    <span
      class="status-label h-50"
      [dpTooltip]="'dpProductCommon.stock.willBeConfirmed' | cxTranslate"
    >To be confirmed</span>
  </ng-template>
}
